import { render, staticRenderFns } from "./MinorResult.vue?vue&type=template&id=64605001&"
import script from "./MinorResult.vue?vue&type=script&lang=js&"
export * from "./MinorResult.vue?vue&type=script&lang=js&"
import style0 from "./MinorResult.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports